"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayArbitrary = void 0;

var Stream_1 = require("../../stream/Stream");

var symbols_1 = require("../../check/symbols");

var integer_1 = require("../integer");

var LazyIterableIterator_1 = require("../../stream/LazyIterableIterator");

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var Converters_1 = require("../../check/arbitrary/definition/Converters");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var ArrayArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(ArrayArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(ArrayArbitrary);

  function ArrayArbitrary(arb, minLength, maxGeneratedLength, maxLength, setBuilder) {
    var _this;

    _classCallCheck(this, ArrayArbitrary);

    _this = _super.call(this);
    _this.arb = arb;
    _this.minLength = minLength;
    _this.maxGeneratedLength = maxGeneratedLength;
    _this.maxLength = maxLength;
    _this.setBuilder = setBuilder;
    _this.lengthArb = (0, Converters_1.convertToNext)((0, integer_1.integer)(minLength, maxGeneratedLength));
    return _this;
  }

  _createClass(ArrayArbitrary, [{
    key: "preFilter",
    value: function preFilter(tab) {
      if (this.setBuilder === undefined) {
        return tab;
      }

      var s = this.setBuilder();

      for (var index = 0; index !== tab.length; ++index) {
        s.tryAdd(tab[index]);
      }

      return s.getData();
    }
  }, {
    key: "generateNItemsNoDuplicates",
    value: function generateNItemsNoDuplicates(setBuilder, N, mrng, biasFactorItems) {
      var numSkippedInRow = 0;
      var s = setBuilder();

      while (s.size() < N && numSkippedInRow < this.maxGeneratedLength) {
        var current = this.arb.generate(mrng, biasFactorItems);

        if (s.tryAdd(current)) {
          numSkippedInRow = 0;
        } else {
          numSkippedInRow += 1;
        }
      }

      return s.getData();
    }
  }, {
    key: "generateNItems",
    value: function generateNItems(N, mrng, biasFactorItems) {
      var items = [];

      for (var index = 0; index !== N; ++index) {
        var current = this.arb.generate(mrng, biasFactorItems);
        items.push(current);
      }

      return items;
    }
  }, {
    key: "wrapper",
    value: function wrapper(itemsRaw, shrunkOnce, itemsRawLengthContext, startIndex) {
      var items = shrunkOnce ? this.preFilter(itemsRaw) : itemsRaw;
      var cloneable = false;
      var vs = [];
      var itemsContexts = [];

      for (var idx = 0; idx !== items.length; ++idx) {
        var s = items[idx];
        cloneable = cloneable || s.hasToBeCloned;
        vs.push(s.value);
        itemsContexts.push(s.context);
      }

      if (cloneable) {
        ArrayArbitrary.makeItCloneable(vs, items);
      }

      var context = {
        shrunkOnce: shrunkOnce,
        lengthContext: itemsRaw.length === items.length && itemsRawLengthContext !== undefined ? itemsRawLengthContext : undefined,
        itemsContexts: itemsContexts,
        startIndex: startIndex
      };
      return new NextValue_1.NextValue(vs, context);
    }
  }, {
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var biasMeta = this.applyBias(mrng, biasFactor);
      var targetSize = biasMeta.size;
      var items = this.setBuilder !== undefined ? this.generateNItemsNoDuplicates(this.setBuilder, targetSize, mrng, biasMeta.biasFactorItems) : this.generateNItems(targetSize, mrng, biasMeta.biasFactorItems);
      return this.wrapper(items, false, undefined, 0);
    }
  }, {
    key: "applyBias",
    value: function applyBias(mrng, biasFactor) {
      if (biasFactor === undefined) {
        return {
          size: this.lengthArb.generate(mrng, undefined).value
        };
      }

      if (this.minLength === this.maxGeneratedLength) {
        return {
          size: this.lengthArb.generate(mrng, undefined).value,
          biasFactorItems: biasFactor
        };
      }

      if (mrng.nextInt(1, biasFactor) !== 1) {
        return {
          size: this.lengthArb.generate(mrng, undefined).value
        };
      }

      if (mrng.nextInt(1, biasFactor) !== 1 || this.minLength === this.maxGeneratedLength) {
        return {
          size: this.lengthArb.generate(mrng, undefined).value,
          biasFactorItems: biasFactor
        };
      }

      var maxBiasedLength = this.minLength + Math.floor(Math.log(this.maxGeneratedLength - this.minLength) / Math.log(2));
      var targetSizeValue = (0, Converters_1.convertToNext)((0, integer_1.integer)(this.minLength, maxBiasedLength)).generate(mrng, undefined);
      return {
        size: targetSizeValue.value,
        biasFactorItems: biasFactor
      };
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      if (!Array.isArray(value) || this.minLength > value.length || value.length > this.maxLength) {
        return false;
      }

      for (var index = 0; index !== value.length; ++index) {
        if (!(index in value)) {
          return false;
        }

        if (!this.arb.canShrinkWithoutContext(value[index])) {
          return false;
        }
      }

      var filtered = this.preFilter(value.map(function (item) {
        return new NextValue_1.NextValue(item, undefined);
      }));
      return filtered.length === value.length;
    }
  }, {
    key: "shrinkItemByItem",
    value: function shrinkItemByItem(value, safeContext, endIndex) {
      var _this2 = this;

      var shrinks = Stream_1.Stream.nil();

      var _loop = function _loop(index) {
        shrinks = shrinks.join((0, LazyIterableIterator_1.makeLazy)(function () {
          return _this2.arb.shrink(value[index], safeContext.itemsContexts[index]).map(function (v) {
            var beforeCurrent = value.slice(0, index).map(function (v, i) {
              return new NextValue_1.NextValue((0, symbols_1.cloneIfNeeded)(v), safeContext.itemsContexts[i]);
            });
            var afterCurrent = value.slice(index + 1).map(function (v, i) {
              return new NextValue_1.NextValue((0, symbols_1.cloneIfNeeded)(v), safeContext.itemsContexts[i + index + 1]);
            });
            return [beforeCurrent.concat(v).concat(afterCurrent), undefined, index];
          });
        }));
      };

      for (var index = safeContext.startIndex; index < endIndex; ++index) {
        _loop(index);
      }

      return shrinks;
    }
  }, {
    key: "shrinkImpl",
    value: function shrinkImpl(value, context) {
      var _this3 = this;

      if (value.length === 0) {
        return Stream_1.Stream.nil();
      }

      var safeContext = context !== undefined ? context : {
        shrunkOnce: false,
        lengthContext: undefined,
        itemsContexts: [],
        startIndex: 0
      };
      return this.lengthArb.shrink(value.length, safeContext.lengthContext).drop(safeContext.shrunkOnce && safeContext.lengthContext === undefined && value.length > this.minLength + 1 ? 1 : 0).map(function (lengthValue) {
        var sliceStart = value.length - lengthValue.value;
        return [value.slice(sliceStart).map(function (v, index) {
          return new NextValue_1.NextValue((0, symbols_1.cloneIfNeeded)(v), safeContext.itemsContexts[index + sliceStart]);
        }), lengthValue.context, 0];
      }).join((0, LazyIterableIterator_1.makeLazy)(function () {
        return value.length > _this3.minLength ? _this3.shrinkItemByItem(value, safeContext, 1) : _this3.shrinkItemByItem(value, safeContext, value.length);
      })).join(value.length > this.minLength ? (0, LazyIterableIterator_1.makeLazy)(function () {
        var subContext = {
          shrunkOnce: false,
          lengthContext: undefined,
          itemsContexts: safeContext.itemsContexts.slice(1),
          startIndex: 0
        };
        return _this3.shrinkImpl(value.slice(1), subContext).filter(function (v) {
          return _this3.minLength <= v[0].length + 1;
        }).map(function (v) {
          return [[new NextValue_1.NextValue((0, symbols_1.cloneIfNeeded)(value[0]), safeContext.itemsContexts[0])].concat(v[0]), undefined, 0];
        });
      }) : Stream_1.Stream.nil());
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this4 = this;

      return this.shrinkImpl(value, context).map(function (contextualValue) {
        return _this4.wrapper(contextualValue[0], true, contextualValue[1], contextualValue[2]);
      });
    }
  }], [{
    key: "makeItCloneable",
    value: function makeItCloneable(vs, shrinkables) {
      var _this5 = this;

      vs[symbols_1.cloneMethod] = function () {
        var cloned = [];

        for (var idx = 0; idx !== shrinkables.length; ++idx) {
          cloned.push(shrinkables[idx].value);
        }

        _this5.makeItCloneable(cloned, shrinkables);

        return cloned;
      };

      return vs;
    }
  }]);

  return ArrayArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.ArrayArbitrary = ArrayArbitrary;